import React, { useState } from 'react';
import { Radio } from 'antd';
import { getUrlParam, insertUrlParam } from 'utils/common';
import { IBPMappingItem, EProviderListMappingStatusValue } from 'types/operation';
import PracticesTable from './PracticesTable';
import ProvidersTable from './ProvidersTable';
import StaffTable from './StaffTable';
import HVATable from './HVATable';
import s from './s.module.less';

type SubTab = 'practices' | 'providers' | 'staff' | 'hva';

const SUB_TABS: { key: SubTab; label: string }[] = [
    { key: 'practices', label: 'Practices' },
    { key: 'providers', label: 'Providers' },
    { key: 'staff', label: 'Staff' },
    { key: 'hva', label: 'HVA' },
];

const VALID_SUB_TABS = new Set<string>(SUB_TABS.map((t) => t.key));

const getInitialSubTab = (): SubTab => {
    const param = getUrlParam('subTab');
    if (param && VALID_SUB_TABS.has(param)) return param as SubTab;
    return 'practices';
};

interface IProps {
    showMappingModal: () => void;
    hideMappingConfirmModal: () => void;
    showMappingConfirmModal: () => void;
    showSlugModal: () => void;
    showTitleModal: () => void;
    showPatientRatingModal: () => void;
    showAutoScheduleModal: () => void;
    showSFUModal: () => void;
    handleSetCurrentRow: (id: IBPMappingItem | null) => void;
    forceReload: Record<any, any>;
    handleListingStatusChange: (id: number, status: EProviderListMappingStatusValue) => void;
    findProviderByEmail: (email: string, type: number) => Promise<any>;
}

const GroupPracticeOpsPage = (props: IProps) => {
    const [subTab, setSubTab] = useState<SubTab>(getInitialSubTab);

    const handleSubTabChange = (key: SubTab) => {
        setSubTab(key);
        insertUrlParam('subTab', key);
    };

    return (
        <div className={s.wrap}>
            <div className={s.subTabWrap}>
                <Radio.Group
                    value={subTab}
                    onChange={(e) => handleSubTabChange(e.target.value)}
                    optionType="button"
                    buttonStyle="outline"
                    options={SUB_TABS.map((tab) => ({ label: tab.label, value: tab.key }))}
                />
            </div>
            {subTab === 'practices' && <PracticesTable />}
            {subTab === 'providers' && <ProvidersTable {...props} />}
            {subTab === 'staff' && <StaffTable />}
            {subTab === 'hva' && <HVATable />}
        </div>
    );
};

export default GroupPracticeOpsPage;
